import { render, staticRenderFns } from "./BasicFilterWrap.vue?vue&type=template&id=8dc1c4aa&scoped=true"
import script from "./BasicFilterWrap.vue?vue&type=script&lang=js"
export * from "./BasicFilterWrap.vue?vue&type=script&lang=js"
import style0 from "./BasicFilterWrap.vue?vue&type=style&index=0&id=8dc1c4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc1c4aa",
  null
  
)

export default component.exports